// extracted by mini-css-extract-plugin
module.exports = {"root":"features_root__2KSqc","doodleBg":"features_doodleBg__3joa1"};